module Shared {
    export class EnumObj {
        constructor(public name: string, public id: any)
        {
        
        }
    }
}